export default "__VITE_PUBLIC_ASSET__d739f898__"